import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-business-days';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import S from './suggestions.scss';

const AssessmentSuggestionsButtons = ({
  queryStart, handleQueryStartChange, errors,
  handleSuggestionSubmit, suggestionKey,
  isCcs, handleShowAssessmentSuggestions,
  loadNewSuggestions, isAfternoon,
}) => {
  const minDate = isAfternoon ? moment().add(1, 'day') : moment();
  const maxDate = minDate.clone().add(2, 'months');

  return (<Fragment>
    <div className={S.stdBtnsContainer}>
      <div className={S.datePickerContainer}>
        <DatePicker
          label="Suggestion Search Start"
          minDate={minDate.toDate()}
          maxDate={maxDate.toDate()}
          value={queryStart}
          onChange={handleQueryStartChange}
          className={S.datePicker}
          placeholder="Select Date"
          error={errors.startDate}
        />
        <ColoredButton
          label="Search From Selected Date"
          color="blue"
          onClick={loadNewSuggestions}
        />
      </div>
      <div className={S.saveBtnContainer}>
        <ColoredButton
          className={S.mainSubmitButton}
          label="Save Assessment"
          onClick={handleSuggestionSubmit}
          disabled={!suggestionKey}
          color="green"
        />
        {!isCcs && <ColoredButton
          label="Switch to Calendar View"
          color="blue"
          onClick={() => handleShowAssessmentSuggestions(false)}
          disabled={false}
        />}
      </div>
    </div>
  </Fragment>);
};

AssessmentSuggestionsButtons.defaultProps = { suggestionKey: null, schedulingReason: '', isDeliveryList: false };

AssessmentSuggestionsButtons.propTypes = {
  isCcs: PropTypes.bool,
  queryStart: PropTypes.string,
  handleQueryStartChange: PropTypes.func,
  errors: PropTypes.object,
  loadNewSuggestions: PropTypes.func,
  handleSuggestionSubmit: PropTypes.func,
  handleShowAssessmentSuggestions: PropTypes.func,
  suggestionKey: PropTypes.string,
  isAfternoon: PropTypes.bool,
};

export default AssessmentSuggestionsButtons;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/assessmentSuggestionsButtons.jsx